module.exports = __webpack_public_path__ + "static/img/game-logo-pg.a3479d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-pg.png
// module id = 4J2o
// module chunks = 0 1 2 3 4 5 6